import {
  CanvasElementType,
  CanvasLayer,
  CanvasObjectPosition,
  CanvasObjectSize,
  CanvasObjectStyles,
} from '@y42/json-schema';
import type { VisualizationCanvasElementStoreModel } from '../visualization-canvas-element.model';
import { defaultCanvasGenericStyles, defaultCanvasObjectProperties } from './default-canvas-model-properties';

export const canvasCommentDefaultSize: CanvasObjectSize = {
  width: 40,
  height: 40,
};

export const canvasCommentStylesDefaultConstant: CanvasObjectStyles = {
  ...defaultCanvasGenericStyles,
};

export function getCanvasCommentModel(data: { position: CanvasObjectPosition }) {
  return {
    type: CanvasElementType.Comment,
    position: data.position,
    size: canvasCommentDefaultSize,
    typeSettings: {},
    objectProperties: {
      ...defaultCanvasObjectProperties,
      resizable: false,
      rotatable: false,
      selectable: false,
    },
    styles: canvasCommentStylesDefaultConstant,
    layer: CanvasLayer.CommentPins,
  };
}

export type CanvasCommentModel = VisualizationCanvasElementStoreModel<CanvasElementType.Comment>;
